export default __webpack_public_path__ + "static/media/roof.d9fa2fe3.png";